module.exports = __webpack_public_path__ + "img/reflection.ec6f0379.png";